import { Calendar } from 'lucide-react';

import type { DeactivatePreflight } from '../../../../api/users';

export interface ImpactRow {
  icon: typeof Calendar;
  label: string;
  detail: string;
  tone: 'warn' | 'info' | 'ok';
  strong?: boolean;
}

/** Build impact rows from the fresh preflight response, not the list's count,
 *  which may be stale. */
export function buildImpactFromPreflight(preflight: DeactivatePreflight): ImpactRow[] {
  const impact: ImpactRow[] = [];
  if (preflight.upcomingWorkshopCount > 0) {
    impact.push({
      icon: Calendar,
      label: `${preflight.upcomingWorkshopCount} upcoming workshop${preflight.upcomingWorkshopCount === 1 ? '' : 's'}`,
      detail: 'Assignments stay in place — reassign manually if needed.',
      tone: 'warn',
      strong: true,
    });
  }
  return impact;
}
